import React from "react";

/**
 * Standardized PageHeader component for all pages
 * @param {string} title - Page main title
 * @param {string} subtitle - Page subtitle / description
 * @param {React.ReactNode} actions - Right side action buttons
 * @param {React.ReactNode} badge - Optional badge or status tag next to title
 */
const PageHeader = ({ title, subtitle, actions = null, badge = null }) => {
  return (
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      flexWrap: "wrap",
      gap: "16px",
      marginBottom: "24px",
      paddingBottom: "16px",
      borderBottom: "1px solid var(--border)"
    }}>
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <h1 style={{
            fontSize: "1.6rem",
            fontWeight: "700",
            color: "var(--text-main)",
            letterSpacing: "-0.02em",
            margin: 0
          }}>
            {title}
          </h1>
          {badge}
        </div>
        {subtitle && (
          <p style={{
            fontSize: "0.9rem",
            color: "var(--text-muted)",
            marginTop: "4px",
            margin: 0
          }}>
            {subtitle}
          </p>
        )}
      </div>

      {actions && (
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          flexWrap: "wrap"
        }}>
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
